import { useContext, useState } from 'react';

import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';
import { CheckResponseShowError } from '@totem/utilities/responseUtilities';

// Approve or reject the current user's bypass approval on a window (existing approver-keyed endpoints).
const useApprovalAction = (onDone: () => void) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [sending, setSending] = useState<boolean>(false);

  const sendApproval = (
    maintenanceWindowId: string,
    decision: 'approve' | 'reject',
  ) => {
    if (sending) {
      return;
    }
    setSending(true);

    fetch(
      `${DEVICES_ENDPOINT}/maintenanceWindows/${maintenanceWindowId}/${decision}`,
      {
        method: 'POST',
        headers: new Headers({ Authorization: `Bearer ${getApiToken()}` }),
      },
    )
      .then((res) => {
        if (CheckResponseShowError(res)) {
          onDone();
        }
      })
      .finally(() => setSending(false));
  };

  return { sending, sendApproval };
};

export default useApprovalAction;
